<script>
  import PageHeader from '/components/Atoms/PageHeader'
  import Card from '/components/Atoms/Card'
  import Link from '/Atoms/Link'

  export let data, title

  let artists = data?.artists

  // groups by first letter of title
  const groups = {}
  for (let artist of artists) {
    const letter = artist.title.substr(0,1).toUpperCase()
    if (groups[letter]) {
      groups[letter].push(artist)
    } else {
      groups[letter] = [artist]
    }
  }

  // sort groups
  const groupsSorted = Object.entries(groups)
    .sort(function (group1, group2) {
      return group1[0].localeCompare(group2[0]);
    })
    // sort within groups
    .map( ([key, value]) => {
      console.log(key, value)
      value = value.sort(function (name1, name2) {
        return name1.title.localeCompare(name2.title);
      })
      return [key, value]
    })

  console.log(groupsSorted)

  // let body = data?.Text?.body || []

</script>

<div class="container">

  <div class="header">
    <PageHeader>
      {title}
    </PageHeader>
  </div>

  <section class="main">
    <Card standardRadius paddingStyle="headline">
      {#if artists}
        <ol>
          {#each groupsSorted as group}
            <h3 class="letter">
              { group[0] }
            </h3>
            <ol class="group">
              {#each group[1] as artist}
                <li class="artist" data-edition={artist.edition} title={`${artist.title} | ${artist.edition}`}>
                  <Link section="people" slug={artist.slug}>
                    {artist.title}
                  </Link>
                </li>
              {/each}
            </ol>
          {/each}
        </ol>
      {/if}
    </Card>
  </section>

  <aside class="side">
    <!--SideGroup /-->
  </aside>

</div>

<style lang="scss">
  .container {
    @include grid-padding;
    @include media-2col {
      @include grid;
    }
  }

  .header {
    grid-column: 1 / span 9;
  }
  .main {
    grid-column: 1 / span 9;
    grid-row: 2;
  }

  .side {
    grid-column: 10 / span 3;
    grid-row: 2;
  }

  code {
    grid-row: 3;
    white-space: pre;
  }

  li, a {
    @include typo-grotesk-text-24;
  }

  .letter {
    @include typo-serif-title-44;
  }

  .group {
    margin-top: 1em;
    &:not(:last-child) {
      margin-bottom: 1em;
    }
  }

  [data-edition="2021"] {
    opacity: 0.5;
  }

</style>